import Model from './model';

export default class ShareOpportunity extends Model {
  static NAME = 'share_opportunity';
  static COLLECTION_NAME = "share_opportunities";
  static URL = '/api/v2/share_opportunities';
}